
import { ISavedAddressDtoModel } from "../models/saved-address/dto/saved-address-dto.model";
import { ISavedAddressPostDtoModel } from "../models/saved-address/dto/saved-address-post-dto.model";
import { ISavedAddressDetailsModel, ISavedAddressModel } from "../models/saved-address/saved-address.model";
import { IModelMapping } from "./generic/model.mapping";
export class SavedAddressMapping implements IModelMapping<ISavedAddressDtoModel, ISavedAddressModel> {
    toApplicationModel(dto: ISavedAddressDtoModel): ISavedAddressModel {
        console.log(dto);
        return {
            id: dto.id,
            concatenatedAddress: `${dto?.details?.addressLine1}, ${dto?.details?.townCity}, ${dto?.details?.postalCode}, ${dto?.details?.countryName}`,
            details: {
                name: dto.details.name,
                addressLine1: dto.details.addressLine1,
                addressLine2: dto.details.addressLine2,
                townCity: dto.details.townCity,
                countyState: dto.details.countyState,
                postalCode: dto.details.postalCode,
                countryCode: dto.details.countryCode,
                countryName: dto.details.countryName,
                country: {
                    name: dto?.details?.countryName ? dto.details.countryName : '',
                    code: dto?.details?.countryCode ? dto.details.countryCode : '',
                },
                isDefault: dto.details.isDefault,
                isResidentialAddress: dto.details.isResidentialAddress,
                isBillToDefault: dto.details.isBillToDefault,
                isBillTo: dto.details.isBillTo,
                isShipTo: dto.details.isShipTo,
                isShipToDefault: dto.details.isShipToDefault,
                isVerified: dto.details.isVerified,
                contactNumber: dto.details.contactNumber
            } as ISavedAddressDetailsModel,
        } as ISavedAddressModel;
    }

    toDtoModel(model: ISavedAddressModel): ISavedAddressDtoModel {
        return { ...model } as unknown as ISavedAddressDtoModel;
    }

    toDtoModels(models: ISavedAddressModel[]): ISavedAddressDtoModel[] {
        return { ...models } as unknown as ISavedAddressDtoModel[];
    }

    toApplicationModels(models: ISavedAddressDtoModel[]): ISavedAddressModel[] {
        return { ...models } as unknown as ISavedAddressModel[];
    }

    toApplicationPostModel(model: ISavedAddressPostDtoModel): ISavedAddressModel {
        return {
            id: model.customerId,
            details: model.address
        } as ISavedAddressModel
    }
}